import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
/* === Addin =====
*/
import {  CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, isDevMode } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

/**================PLUGINS =========*/
//import { FCM } from '@ionic-native/fcm/ngx'; //https://ionicframework.com/docs/native/fcm
import { IonicStorageModule } from '@ionic/storage-angular';//https://ionicframework.com/docs/angular/storage

/**================SERVICES =========*/
import { SqliteService } from './services/sqlite.service';


/**
 * recaptcha 
 */
import { RecaptchaModule } from 'ng-recaptcha-2';
/** SENTRY */
import * as Sentry from "@sentry/capacitor";
// Use @sentry/angular for Angular 12+ or `@sentry/angular` from Angular 10 and 11
import * as SentryAngular from "@sentry/angular";

//custom service
import { GlobalErrorHandler } from './services/global-error-handler.service'

Sentry.init(
  {
    dsn: "https://d87ea8eb587e64219a646857362ee983@o1061157.ingest.sentry.io/4506161340481536",

    // Set your release version, such as "getsentry@1.0.0"
    release: "aba-check-v2@3.1.0",
    // Set your dist version, such as "1"
    dist: "1.0.3",
    ignoreErrors: [
      "duplicate column name" ,
      "SelectSQL: queryAll: undefined",
      "isProxied",
      "Error: location unavailable",
      "ApplicationNotResponding",
      "Cannot read properties of undefined (reading 'connectionType')",
      "Sync already in progress", //for ionic deploy if try to sync twice
    ],
    beforeSend(event, hint) {
      if (hint.originalException === "Timeout") return null; //remove timeout errors as down to google recaptcha
      console.log("🚀 ~ file: app.module.ts:53 ~ event:", event)
      return event
    }
    /*integrations: [
      // Registers and configures the Tracing integration,
      // which automatically instruments your application to monitor its
      // performance, including custom Angular routing instrumentation
      new SentryAngular.BrowserTracing({
        tracePropagationTargets: ["localhost", "https://yourserver.io/api"],
        routingInstrumentation: SentryAngular.routingInstrumentation,
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,*/
  },
  // Forward the init method from @sentry/angular
  SentryAngular.init
);


/**
 * SHARED components
 */
import { SharedModule } from './shared/shared.module';

import { FileTransfer, FileUploadOptions, FileTransferObject } from '@awesome-cordova-plugins/file-transfer/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { ServiceWorkerModule } from '@angular/service-worker';



@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule, //addin
        IonicStorageModule.forRoot({
            name: '__aba_check_db'
        }),
        //added
        SharedModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        }),
        RecaptchaModule], providers: [
        SqliteService,
        File,
        FileTransfer,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
